import { render, staticRenderFns } from "./TradeLogistic.vue?vue&type=template&id=465c7ae2&scoped=true&"
import script from "./TradeLogistic.vue?vue&type=script&lang=js&"
export * from "./TradeLogistic.vue?vue&type=script&lang=js&"
import style0 from "./TradeLogistic.vue?vue&type=style&index=0&id=465c7ae2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465c7ae2",
  null
  
)

export default component.exports